import { useStore } from 'zustand';
import type { ChartId } from '../types/commontypes';
import type { RenderNodesMap, ShapeType } from '@/types/commontypes';
import { entries, useChartShapes } from '..';

export const deleteShape = (
  uuid: string,
  renderNodes: RenderNodesMap,
  chartId: ChartId,
  type: ShapeType,
): RenderNodesMap => {
  // Copy renderNodes for immutability
  const updatedShapes: RenderNodesMap = { ...renderNodes };

  // Only update the targeted chart
  const chartShapes = renderNodes[chartId];
  if (chartShapes) {
    // Copy the chart shapes object for immutability
    const updatedChartShapes = { ...chartShapes };

    if (updatedChartShapes[type]) {
      // Filter out the shape with the given uuid
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion -- RenderNodesMap의 mapped type에서 .filter() 반환 타입 호환을 위한 캐스트
      (updatedChartShapes as any)[type] = updatedChartShapes[type].filter(shape => shape.uuid !== uuid);
    }
    updatedShapes[chartId] = updatedChartShapes;
  }

  // deleteRenderNode removed - coordinates now stored in renderNodes
  return updatedShapes;
};

export interface DeleteShapeIds {
  uuid: string;
  chartId: ChartId | undefined;
}

export const useDeleteShape = () => {
  // Get from contexts
  const { shapeStore } = useChartShapes();
  const renderNodes = useStore(shapeStore, s => s.renderNodes);
  const setRenderNodes = useStore(shapeStore, s => s.setRenderNodes);

  // Handle shape deletion
  const handleDelete = (key: string) => {
    let type: ShapeType | undefined;
    let chartId: ChartId | undefined;

    // New structure: renderNodes[chartId][type][]
    entries(renderNodes).forEach(([cid, chartShapes]) => {
      entries(chartShapes).forEach(([eachShapeType, shapeArray]) => {
        if (shapeArray.some(shape => shape.uuid === key)) {
          type = eachShapeType;
          chartId = cid;
        }
      });
    });

    if (!key || !chartId || !type) return;
    setRenderNodes(prev => deleteShape(key, prev, chartId!, type!));
    shapeStore.getState().markDeleted(key);
  };
  return { handleDelete };
};
